import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "block mb-2 text-sm leading-6 font-semibold tracking-wider text-blue-900" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-700" }, "*", -1)
const _hoisted_4 = { class: "flex justify-between mb-6" }
const _hoisted_5 = { class: "text-sm leading-6 flex items-center gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "checkall" }, "Pilih Semua", -1)
const _hoisted_7 = {
  key: 0,
  class: "text-center"
}
const _hoisted_8 = {
  key: 1,
  class: "grid grid-cols-3 gap-4"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "text-xl leading-7 font-semibold tracking-wider text-blue-900 mb-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-xs leading-5 tracking-wide text-gray-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" Pilih Asesmen (" + _toDisplayString(_ctx.selectedAssessment.length) + " Terpilih)", 1),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          id: "checkall",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkAll) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.checkAll]
        ]),
        _hoisted_6
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "rounded border p-2 w-60",
        placeholder: "Cari asesmen",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterAssessment) = $event))
      }, null, 512), [
        [_vModelText, _ctx.filterAssessment]
      ])
    ]),
    (!_ctx.filteredAssessments.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, "No Data"))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAssessments, (assessment) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.selectAssessment(assessment.id)),
              key: assessment.id,
              class: _normalizeClass(["border-1 rounded-2xl p-4 text-center cursor-pointer", {
          'border-blue-700 shadow-lg': _ctx.isAssessmentChosen(assessment.id),
        }])
            }, [
              _createElementVNode("img", {
                src: assessment.image,
                alt: `${assessment.name} image`,
                class: "w-20 h-20 bg-gray-300 my-4 mx-auto rounded-full"
              }, null, 8, _hoisted_10),
              _createElementVNode("div", _hoisted_11, _toDisplayString(assessment.name), 1),
              (assessment.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(assessment.description.substring(0, 80)) + " ... ", 1))
                : _createCommentVNode("", true)
            ], 10, _hoisted_9))
          }), 128))
        ]))
  ]))
}